// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a318e3f7","239":"76964962","455":"81be20ba"}[chunkId] + ".chunk.js";
};